import React, { useState } from 'react';

import * as api from '../../api';
import { type ErrorMessage } from '../../models';

import OtpForm from './OtpForm';

interface SentOtpFormProps {
  sentFactorType: 'email' | 'sms';

  /** Fired when the code is successfully verified */
  onSuccess: () => void;

  /** Fired when the code verification fails */
  onFailure: () => void;

  /** Whether the form should be submitted */
  isCodeReadyForSubmission: boolean;

  /** Fired when the form becomes submittable or not */
  onSubmittableChange: (state: boolean) => void;
}

/**
 * Generic component for initiating a code verification (e.g. via email or SMS)
 * and then renders a form to verify it.
 */
export default function SentOtpForm({
  sentFactorType,
  onFailure: handleFailure,
  onSuccess: handleSuccess,
  isCodeReadyForSubmission,
  onSubmittableChange: handleSubmittableChange,
}: SentOtpFormProps): JSX.Element {
  const [isReadyToVerify, setIsReadyToVerify] = useState(false);

  const handleMount = async () => {
    await api.sendOtpCode(sentFactorType);
    setIsReadyToVerify(true);
  };

  const handleVerify = async (code: string): Promise<boolean | ErrorMessage> =>
    api.validateOtpCode(code, sentFactorType);

  return (
    <OtpForm
      onMount={handleMount}
      isReadyToVerify={isReadyToVerify}
      isCodeReadyForSubmission={isCodeReadyForSubmission}
      onVerify={handleVerify}
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      onSubmittableChange={handleSubmittableChange}
    />
  );
}
